const APPLIANCES = '/images/services/appliances';

export const APPLIANCE_SERVICE_IMAGES: Record<string, string> = {
  'refrigerator-repair': `${APPLIANCES}/refrigerator-repair.webp`,
  'washer-dryer': `${APPLIANCES}/washer-dryer.webp`,
  'washer-repair': `${APPLIANCES}/washer-dryer.webp`,
  'dryer-repair': `${APPLIANCES}/washer-dryer.webp`,
  'dishwasher-repair': '/images/services/dishwasher-repair.webp',
  'oven-stove-repair': '/images/services/oven-stove-repair.webp',
  'cooktop-repair': `${APPLIANCES}/cooktop-repair.webp`,
  'microwave-repair': `${APPLIANCES}/microwave-repair.webp`,
  'garbage-disposal-repair': `${APPLIANCES}/garbage-disposal-repair.webp`,
  'ice-maker-repair': `${APPLIANCES}/refrigerator-repair.webp`,
};

export const APPLIANCE_DEFAULT_IMAGE = `${APPLIANCES}/technician-default.webp`;
